module.exports = __webpack_public_path__ + "img/yklogo2.19e0fd6d.png";